import React, { useEffect } from "react";
import { Table, Switch, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useMaintenanceModel } from "../MaintenanceModel";
import { IMaintenanceDetail } from "../MaintenanceType";
import moment, { Moment } from "moment";
import { momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import useNavModel from "@/model/navModel";
export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,descRows,
        loadData, setSelectedRowKeys,setDescRows
    } = useMaintenanceModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const onLook = (record: IMaintenanceDetail) => {
        let { maintenanceCode, tradeTypeCode } = record
        replaceNav(selectedNavId, "2-2-3", { id: maintenanceCode as string, mode: "look", }, true);
    }
    const columns: ColumnsType<IMaintenanceDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`,
            fixed: "left"
        }, {
            // title: '单据编码',
            title: Locale["Document No."],
            width: 150,
            dataIndex: 'maintenanceCode',
            fixed: "left",
            render: (text, record) => <span onClick={() => onLook(record)} className="click-span">{text}</span>
        }, {
            // title: '客户名称',
            title: Locale["Customer"],
            width: 100,
            dataIndex: 'customerName',
        }, {
            // title: '车牌号',
            title: Locale["License Plate"],
            width: 130,
            dataIndex: 'licensePlate',
        }, {
            // title: '工时费',
            title: Locale["Labor Cost"],
            width: 130,
            dataIndex: 'workingHoursAmount',
        }, {
            // title: '零件费',
            title: Locale["Material Cost"],
            width: 130,
            dataIndex: 'materialScienceAmount',
        }, {
            // title: '应收金额',
            title: Locale["Receivable Amount"],
            width: 130,
            dataIndex: 'receivableTotalAmount',
        }, {
            // title: '已收金额',
            title: Locale["Received Amount"],
            width: 130,
            dataIndex: 'amountReceived',
        }, {
            // title: '制单人',
            title: Locale["Creator"],
            width: 130,
            dataIndex: 'createUser',
        }, {
            // title: '制单时间',
            title: Locale["Creation Time"],
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }
    ];


    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (record: IMaintenanceDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMaintenanceDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
